import React, { useContext, useState, useEffect } from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import GroupBiorepositoryOps from "../FieldTags/GroupBiorepositoryOps";
import { UserContext } from "../../context/UserContext";
import pullListLabels from "../../util/PullListLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const statuses = [
    "Real Time",
    "Pull List Development",
    "Pending Pull List Approval",
    "Pull List Approved",
    "Submitted to Repository",
    "Pull List Executed",
    "Results Data Processing",
    "Pending Follow-up",
    "Completed",
    "Withdrawn",
];

const defaultHiddenStatuses = [
    "Real Time",
    "Pull List Approved",
    "Submitted to Repository",
    "Pull List Executed",
];

const withdrawableStatuses = [
    "Real Time",
    "Pull List Development",
    "Pending Pull List Approval",
    "Pull List Approved",
    "Submitted to Repository",
];

const Status = ({ status, handleChange, pullLists, shipmentFromRepo, shipDate, validationStatus, sampleDisposal}) => {
    const { user } = useContext(UserContext);

    const [localStatus, setLocalStatus] = useState(status);
    const [hiddenStatuses, setHiddenStatuses] = useState(defaultHiddenStatuses);

    const canEdit = checkRole(user, ROLES.ELEVATED);
    const canOverride = checkRole(user, [ROLES.ADMIN]);
    const canSelectFinalStatus = checkRole(user, [ROLES.APPROVER]);
    const canBeWithdrawn = !shipDate && withdrawableStatuses.includes(status);
    const canBeCompleted =
        (shipmentFromRepo === "Sample Disposal" && status === "Pull List Executed") ||
        (shipmentFromRepo === "Yes" && (validationStatus === "Validation Complete" || validationStatus === "Validation Not Required")) ||
        (shipmentFromRepo === "No" && (status === "Pull List Approved" || (validationStatus === "Validation Complete" || validationStatus === "Validation Not Required")));

    useEffect(() => {
        setLocalStatus(status);
    }, [status]);

    useEffect(() => {
        let newHiddenStatuses = [...defaultHiddenStatuses];

        if (shipmentFromRepo === "No" && sampleDisposal === "No") {
            newHiddenStatuses.push("Pull List Development", "Pending Pull List Approval");
        }

        if (!canSelectFinalStatus) {
            newHiddenStatuses.push("Completed", "Withdrawn");
        }

        setHiddenStatuses(newHiddenStatuses);
    }, [shipmentFromRepo, sampleDisposal, canSelectFinalStatus]);

    const handleDropdownChange = (e) => {
        setLocalStatus(e.target.value);
        handleChange("status", e.target.value);
    };

    return (
        <div className="planField">
            <GroupBiorepositoryOps />
            <FormControl variant="standard">
                <InputLabel shrink={true}>{pullListLabels.status}</InputLabel>
                <Select
                    id="status-field"
                    name="status"
                    notched={true}
                    value={localStatus ? localStatus  : ""}
                    onChange={handleDropdownChange}
                    disabled={!canEdit}
                >
                    {statuses.map((menuStatus) => (
                        <MenuItem
                            key={menuStatus}
                            value={menuStatus}
                            style={{ display: hiddenStatuses.includes(menuStatus) ? "none" : "block" }}
                            disabled={
                                (!canOverride) &&
                                ((menuStatus === "Withdrawn" && !canBeWithdrawn) || (menuStatus === "Completed" && !canBeCompleted))
                            }
                        >
                            {menuStatus}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            <HistoryLogElement pullLists={pullLists} label={"status"} />
        </div>
    );
};

export default Status;